import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { QuotaAlert } from "./QuotaAlert";
import { Toaster } from "../ui/sonner";
import { MobileBottomNav } from "../mobile/MobileBottomNav";
import { PWAInstallPrompt } from "../mobile/PWAInstallPrompt";
import HelpChatWidget from "../help/HelpChatWidget";

export const DashboardLayout = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <div className="min-h-screen bg-background" data-testid="dashboard-layout">
            {/* Offline Indicator */}
            <div className={`offline-indicator ${isOffline ? 'visible' : ''}`}>
                Mode hors ligne - Certaines fonctionnalités peuvent être limitées
            </div>

            {/* Desktop Sidebar - Hidden on mobile */}
            <div className="hidden md:block">
                <Sidebar />
            </div>

            {/* Main Content */}
            <div className="md:pl-64 transition-all duration-300">
                <Header />
                <main className="p-4 md:p-6 lg:p-8 main-content-with-bottom-nav md:pb-8">
                    <QuotaAlert />
                    <Outlet />
                </main>
            </div>

            {/* Mobile Bottom Navigation */}
            <MobileBottomNav />

            {/* PWA Install Prompt */}
            <PWAInstallPrompt />

            {/* AI Help Center */}
            <HelpChatWidget />

            <Toaster position="top-right" richColors />
        </div>
    );
};
